enum ContentSlotBanner {
  COVER_BANNER = 'coverBanner',
}

export default ContentSlotBanner;
